var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb207",
    d: "M57.6 40.2V13.05a5.39 5.39 0 0 0-5.4-5.4H5.4a5.39 5.39 0 0 0-5.4 5.4v30.6a5.39 5.39 0 0 0 5.4 5.4h28.46l-.75 1.3a4 4 0 0 0 3.46 6H60a4 4 0 0 0 3.46-6Zm-7.07-28.95L32.19 26a5.44 5.44 0 0 1-6.78 0L7.07 11.25Zm-43 34.2 15.9-11.13-2.07-2.94L3.61 43.79V13.08l19.55 15.74a9.06 9.06 0 0 0 11.28 0L54 13.08V34l-2.25-3.89a4 4 0 0 0-6.93 0l-3 5.19-5.56-3.88-2.06 2.9 5.8 4.07-4.07 7.06Zm29.06 6.91 11.7-20.29L60 52.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb207",
    d: "M46.29 36.21h4v10h-4zM46.29 47.21h4v4h-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPending);
export default __webpack_public_path__ + "static/media/email-pending.9a254423bd876b975554b48b14cac8a5.svg";
export { ForwardRef as ReactComponent };